import { Ident } from '@mode-switch/express';
import { PivotQuery } from './PivotQuery';
import { Query } from './Query';
export var PivotBasic;
(function (PivotBasic) {
    function make(model, viewName, source) {
        var _a;
        const pivot = {
            id: Ident.next(),
            model,
            viewName,
            parts: [],
            queries: [],
            type: "PIVOT_BASIC",
        };
        let queryName = Ident.next('basic:');
        let markFields = [];
        switch (source.type) {
            case "BASIC": {
                queryName = source.name;
                markFields = [...PivotQuery.Marks.fields(source.marks || {})];
                break;
            }
            case "DETAIL": {
                const series = (_a = source.series) !== null && _a !== void 0 ? _a : [];
                queryName =
                    series.length > 0
                        ? `basic:series_${series.map(PivotQuery.Series.name)}`
                        : queryName;
                markFields = series.reduce((fields, series) => {
                    return [...fields, ...PivotQuery.Marks.fields(series.marks || {})];
                }, []);
                break;
            }
        }
        const { filters, detail, sorts, limit, offset } = source;
        const column = new Map();
        const x = new Map();
        const row = new Map();
        const y = new Map();
        const marks = new Map();
        const names = new Map();
        const values = new Map();
        const normalizeNamesAndValues = (field) => {
            switch (field.source) {
                case "NAMES": {
                    if (names.size === 0) {
                        for (const value of source.values || []) {
                            names.set(value.alias, value);
                        }
                    }
                    break;
                }
                case "VALUES": {
                    if (values.size === 0) {
                        for (const value of source.values || []) {
                            names.set(value.alias, value);
                            values.set(value.alias, value);
                        }
                    }
                    break;
                }
            }
        };
        for (const field of source.column || []) {
            normalizeNamesAndValues(field);
            column.set(field.alias, field);
        }
        for (const field of source.x || []) {
            normalizeNamesAndValues(field);
            x.set(field.alias, field);
        }
        for (const field of source.row || []) {
            normalizeNamesAndValues(field);
            row.set(field.alias, field);
        }
        for (const field of source.y || []) {
            normalizeNamesAndValues(field);
            y.set(field.alias, field);
        }
        for (const field of markFields) {
            normalizeNamesAndValues(field);
            marks.set(field.alias, field);
        }
        return Queries.add(pivot, Query.Pivot.make({
            name: queryName,
            sorts,
            filters,
            detail,
            limit,
            offset,
            column: Array.from(column.values()),
            x: Array.from(x.values()),
            row: Array.from(row.values()),
            y: Array.from(y.values()),
            marks: Array.from(marks.values()),
            names: Array.from(names.values()),
            values: Array.from(values.values()),
        }));
    }
    PivotBasic.make = make;
    function extend(target, source) {
        return {
            ...target,
            queries: [...target.queries, ...source.queries],
        };
    }
    PivotBasic.extend = extend;
    let Queries;
    (function (Queries) {
        function add(pivot, query) {
            return { ...pivot, queries: [...pivot.queries, query] };
        }
        Queries.add = add;
    })(Queries = PivotBasic.Queries || (PivotBasic.Queries = {}));
})(PivotBasic || (PivotBasic = {}));
